'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import StatusBadge from '@/components/ui/StatusBadge';
import MomentumBadge from '@/components/ui/MomentumBadge';
import ConfirmModal from '@/components/ui/ConfirmModal';
import Icon from '@/components/ui/AppIcon';

type CreatorStatus = 'active' | 'pending' | 'paused' | 'draft' | 'archived';

interface Creator {
  id: string;
  name: string;
  handle: string;
  category: string;
  city: string;
  followers: string;
  engagement: number;
  momentum: number;
  status: CreatorStatus;
  verified: boolean;
  campaigns: number;
  lastActive: string;
  avatar: string;
  avatarAlt: string;
  // platform stats
  instagram?: {followers: string;engagement: number;avgViews: string;};
  tiktok?: {followers: string;engagement: number;avgViews: string;};
  snapchat?: {followers: string;engagement: number;avgViews: string;};
  youtube?: {followers: string;engagement: number;avgViews: string;};
  email?: string;
  phone?: string;
}

const creatorsData: Creator[] = [
{
  id: 'adm-yasmine', name: 'Yasmine Belkacem', handle: '@yasmine.create', category: 'Lifestyle · Beauty',
  city: 'Alger', followers: '284K', engagement: 8.7, momentum: 94, status: 'active',
  verified: true, campaigns: 12, lastActive: '18 Aoû 2026',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1160a4e29-1765724500182.png",
  avatarAlt: 'Yasmine Belkacem admin view',
  instagram: { followers: '284K', engagement: 8.7, avgViews: '42K' },
  tiktok: { followers: '190K', engagement: 11.2, avgViews: '85K' },
  snapchat: { followers: '95K', engagement: 6.1, avgViews: '30K' },
  email: 'yasmine.belkacem@email.com', phone: '+213 555 001 001'
},
{
  id: 'adm-lina', name: 'Lina Meziane', handle: '@lina.beauty', category: 'Beauty · Fashion',
  city: 'Constantine', followers: '317K', engagement: 9.4, momentum: 91, status: 'active',
  verified: true, campaigns: 18, lastActive: '17 Aoû 2026',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1160a4e29-1765724500182.png",
  avatarAlt: 'Lina Meziane admin view',
  instagram: { followers: '317K', engagement: 9.4, avgViews: '58K' },
  tiktok: { followers: '240K', engagement: 12.1, avgViews: '110K' },
  youtube: { followers: '45K', engagement: 4.2, avgViews: '18K' },
  email: 'lina.meziane@email.com', phone: '+213 555 002 002'
},
{
  id: 'adm-sarah', name: 'Sarah Hamdi', handle: '@sarah.h', category: 'Lifestyle · Family',
  city: 'Oran', followers: '182K', engagement: 7.2, momentum: 87, status: 'active',
  verified: true, campaigns: 7, lastActive: '16 Aoû 2026',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1160a4e29-1765724500182.png",
  avatarAlt: 'Sarah Hamdi admin view',
  instagram: { followers: '182K', engagement: 7.2, avgViews: '28K' },
  snapchat: { followers: '60K', engagement: 5.8, avgViews: '20K' },
  email: 'sarah.hamdi@email.com', phone: '+213 555 003 003'
},
{
  id: 'adm-amel', name: 'Amel Bensalem', handle: '@amel.bensalem', category: 'Beauty',
  city: 'Alger', followers: '156K', engagement: 9.1, momentum: 88, status: 'active',
  verified: true, campaigns: 9, lastActive: '18 Aoû 2026',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1160a4e29-1765724500182.png",
  avatarAlt: 'Amel Bensalem admin view',
  instagram: { followers: '156K', engagement: 9.1, avgViews: '35K' },
  tiktok: { followers: '88K', engagement: 13.4, avgViews: '60K' },
  email: 'amel.bensalem@email.com', phone: '+213 555 004 004'
},
{
  id: 'adm-karim', name: 'Karim Oussedik', handle: '@karim.tech', category: 'Tech · Business',
  city: 'Alger', followers: '94K', engagement: 5.9, momentum: 79, status: 'active',
  verified: true, campaigns: 14, lastActive: '15 Aoû 2026',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19b3fe9e0-1773215727744.png",
  avatarAlt: 'Karim Oussedik admin view',
  instagram: { followers: '94K', engagement: 5.9, avgViews: '14K' },
  youtube: { followers: '120K', engagement: 3.8, avgViews: '22K' },
  tiktok: { followers: '55K', engagement: 7.2, avgViews: '30K' },
  email: 'karim.oussedik@email.com', phone: '+213 555 005 005'
},
{
  id: 'adm-sofiane', name: 'Sofiane Rahmani', handle: '@sofiane.food', category: 'Food',
  city: 'Alger', followers: '73K', engagement: 7.8, momentum: 82, status: 'active',
  verified: false, campaigns: 4, lastActive: '14 Aoû 2026',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19b3fe9e0-1773215727744.png",
  avatarAlt: 'Sofiane Rahmani admin view',
  instagram: { followers: '73K', engagement: 7.8, avgViews: '12K' },
  tiktok: { followers: '40K', engagement: 9.5, avgViews: '25K' },
  email: 'sofiane.rahmani@email.com', phone: '+213 555 006 006'
},
{
  id: 'adm-nadia', name: 'Nadia Cherif', handle: '@nadia.fashion', category: 'Fashion',
  city: 'Alger', followers: '209K', engagement: 6.4, momentum: 76, status: 'active',
  verified: true, campaigns: 6, lastActive: '13 Aoû 2026',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1160a4e29-1765724500182.png",
  avatarAlt: 'Nadia Cherif admin view',
  instagram: { followers: '209K', engagement: 6.4, avgViews: '32K' },
  snapchat: { followers: '75K', engagement: 4.9, avgViews: '18K' },
  email: 'nadia.cherif@email.com', phone: '+213 555 007 007'
},
{
  id: 'adm-rania', name: 'Rania Touati', handle: '@rania.lifestyle', category: 'Lifestyle',
  city: 'Annaba', followers: '128K', engagement: 8.3, momentum: 71, status: 'paused',
  verified: true, campaigns: 5, lastActive: '10 Aoû 2026',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1160a4e29-1765724500182.png",
  avatarAlt: 'Rania Touati admin view',
  instagram: { followers: '128K', engagement: 8.3, avgViews: '22K' },
  tiktok: { followers: '70K', engagement: 10.1, avgViews: '40K' },
  email: 'rania.touati@email.com', phone: '+213 555 008 008'
},
{
  id: 'adm-imane', name: 'Imane Kaci', handle: '@imane.kaci', category: 'Beauty · UGC',
  city: 'Blida', followers: '22K', engagement: 14.8, momentum: 64, status: 'pending',
  verified: false, campaigns: 0, lastActive: '18 Aoû 2026',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1160a4e29-1765724500182.png",
  avatarAlt: 'Imane Kaci admin view',
  instagram: { followers: '22K', engagement: 14.8, avgViews: '5K' },
  email: 'imane.kaci@email.com', phone: '+213 555 009 009'
},
{
  id: 'adm-omar', name: 'Omar Hadjadj', handle: '@omar.edu', category: 'Education · Business',
  city: 'Sétif', followers: '31K', engagement: 11.2, momentum: 61, status: 'pending',
  verified: false, campaigns: 0, lastActive: '17 Aoû 2026',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19b3fe9e0-1773215727744.png",
  avatarAlt: 'Omar Hadjadj admin view',
  youtube: { followers: '31K', engagement: 11.2, avgViews: '8K' },
  email: 'omar.hadjadj@email.com', phone: '+213 555 010 010'
},
{
  id: 'adm-bilal', name: 'Bilal Mansouri', handle: '@bilal.gaming', category: 'Gaming',
  city: 'Alger', followers: '41K', engagement: 5.2, momentum: 73, status: 'active',
  verified: false, campaigns: 1, lastActive: '12 Aoû 2026',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19b3fe9e0-1773215727744.png",
  avatarAlt: 'Bilal Mansouri admin view',
  tiktok: { followers: '41K', engagement: 5.2, avgViews: '15K' },
  youtube: { followers: '18K', engagement: 4.1, avgViews: '6K' },
  email: 'bilal.mansouri@email.com', phone: '+213 555 011 011'
},
{
  id: 'adm-mehdi', name: 'Mehdi Terki', handle: '@mehdi.sport', category: 'Sport · Lifestyle',
  city: 'Annaba', followers: '27K', engagement: 10.4, momentum: 55, status: 'draft',
  verified: false, campaigns: 0, lastActive: '8 Aoû 2026',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19b3fe9e0-1773215727744.png",
  avatarAlt: 'Mehdi Terki admin view',
  instagram: { followers: '27K', engagement: 10.4, avgViews: '4K' },
  email: 'mehdi.terki@email.com', phone: '+213 555 012 012'
}];


const statusOptions: CreatorStatus[] = ['active', 'pending', 'paused', 'draft', 'archived'];

const PLATFORMS = ['instagram', 'tiktok', 'snapchat', 'youtube'] as const;
type Platform = typeof PLATFORMS[number];

const PLATFORM_LABELS: Record<Platform, string> = {
  instagram: 'Instagram',
  tiktok: 'TikTok',
  snapchat: 'Snapchat',
  youtube: 'YouTube'
};

const PLATFORM_COLORS: Record<Platform, string> = {
  instagram: 'bg-pink-500/15 text-pink-400 border-pink-500/30',
  tiktok: 'bg-cyan-500/15 text-cyan-400 border-cyan-500/30',
  snapchat: 'bg-yellow-400/15 text-yellow-400 border-yellow-400/30',
  youtube: 'bg-red-500/15 text-red-400 border-red-500/30'
};

// ─── Edit Modal ────────────────────────────────────────────────────────────────
function EditCreatorModal({ creator, onSave, onClose



}: {creator: Creator;onSave: (updated: Creator) => void;onClose: () => void;}) {
  const [form, setForm] = useState({ ...creator });

  const set = (field: keyof Creator, value: string) =>
  setForm((prev) => ({ ...prev, [field]: value }));

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-2xl w-full max-w-lg shadow-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between px-6 py-4 border-b border-border sticky top-0 bg-card z-10">
          <h2 className="text-base font-700 text-foreground">Modifier le créateur</h2>
          <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-muted text-muted-foreground hover:text-foreground transition-all">
            <Icon name="XMarkIcon" size={18} />
          </button>
        </div>
        <div className="p-6 space-y-4">
          {/* Basic info */}
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-600 text-muted-foreground mb-1.5">Nom complet</label>
              <input value={form.name} onChange={(e) => set('name', e.target.value)}
              className="w-full bg-muted border border-border rounded-lg px-3 py-2 text-sm text-foreground outline-none focus:border-primary transition-colors" />
            </div>
            <div>
              <label className="block text-xs font-600 text-muted-foreground mb-1.5">Handle</label>
              <input value={form.handle} onChange={(e) => set('handle', e.target.value)}
              className="w-full bg-muted border border-border rounded-lg px-3 py-2 text-sm text-foreground outline-none focus:border-primary transition-colors" />
            </div>
            <div>
              <label className="block text-xs font-600 text-muted-foreground mb-1.5">Catégorie</label>
              <input value={form.category} onChange={(e) => set('category', e.target.value)}
              className="w-full bg-muted border border-border rounded-lg px-3 py-2 text-sm text-foreground outline-none focus:border-primary transition-colors" />
            </div>
            <div>
              <label className="block text-xs font-600 text-muted-foreground mb-1.5">Ville</label>
              <input value={form.city} onChange={(e) => set('city', e.target.value)}
              className="w-full bg-muted border border-border rounded-lg px-3 py-2 text-sm text-foreground outline-none focus:border-primary transition-colors" />
            </div>
            <div>
              <label className="block text-xs font-600 text-muted-foreground mb-1.5">Followers</label>
              <input value={form.followers} onChange={(e) => set('followers', e.target.value)}
              className="w-full bg-muted border border-border rounded-lg px-3 py-2 text-sm text-foreground outline-none focus:border-primary transition-colors" />
            </div>
            <div>
              <label className="block text-xs font-600 text-muted-foreground mb-1.5">Engagement (%)</label>
              <input type="number" step="0.1" value={form.engagement}
              onChange={(e) => setForm((p) => ({ ...p, engagement: parseFloat(e.target.value) || 0 }))}
              className="w-full bg-muted border border-border rounded-lg px-3 py-2 text-sm text-foreground outline-none focus:border-primary transition-colors" />
            </div>
            <div>
              <label className="block text-xs font-600 text-muted-foreground mb-1.5">Email</label>
              <input value={form.email || ''} onChange={(e) => set('email', e.target.value)}
              className="w-full bg-muted border border-border rounded-lg px-3 py-2 text-sm text-foreground outline-none focus:border-primary transition-colors" />
            </div>
            <div>
              <label className="block text-xs font-600 text-muted-foreground mb-1.5">Téléphone</label>
              <input value={form.phone || ''} onChange={(e) => set('phone', e.target.value)}
              className="w-full bg-muted border border-border rounded-lg px-3 py-2 text-sm text-foreground outline-none focus:border-primary transition-colors" />
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex-1">
              <label className="block text-xs font-600 text-muted-foreground mb-1.5">Statut</label>
              <select value={form.status} onChange={(e) => setForm((p) => ({ ...p, status: e.target.value as CreatorStatus }))}
              className="w-full bg-muted border border-border rounded-lg px-3 py-2 text-sm text-foreground outline-none focus:border-primary transition-colors">
                {statusOptions.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div className="flex items-center gap-2 mt-5">
              <input type="checkbox" id="edit-verified" checked={form.verified}
              onChange={(e) => setForm((p) => ({ ...p, verified: e.target.checked }))}
              className="accent-primary w-4 h-4" />
              <label htmlFor="edit-verified" className="text-sm font-600 text-foreground">Vérifié</label>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-border">
          <button onClick={onClose} className="px-4 py-2 rounded-lg text-sm font-600 bg-muted text-muted-foreground hover:text-foreground transition-all">
            Annuler
          </button>
          <button onClick={() => onSave(form)} className="px-4 py-2 rounded-lg text-sm font-600 bg-primary text-primary-foreground hover:bg-primary/90 transition-all active:scale-95">
            Enregistrer
          </button>
        </div>
      </div>
    </div>);

}

// ─── Excel Export Modal ────────────────────────────────────────────────────────
function ExcelExportModal({ creators, selectedIds, onClose



}: {creators: Creator[];selectedIds: string[];onClose: () => void;}) {
  const [exportScope, setExportScope] = useState<'selected' | 'all'>(selectedIds.length > 0 ? 'selected' : 'all');
  const [platforms, setPlatforms] = useState<Record<Platform, boolean>>({ instagram: true, tiktok: true, snapchat: false, youtube: false });
  const [fields, setFields] = useState({ stats: true, email: true, phone: false });
  const [baseFields, setBaseFields] = useState({ name: true, handle: true, category: true, city: true, followers: true, engagement: true, momentum: true, campaigns: true, status: true });

  const togglePlatform = (p: Platform) => setPlatforms((prev) => ({ ...prev, [p]: !prev[p] }));
  const toggleField = (f: keyof typeof fields) => setFields((prev) => ({ ...prev, [f]: !prev[f] }));
  const toggleBase = (f: keyof typeof baseFields) => setBaseFields((prev) => ({ ...prev, [f]: !prev[f] }));

  const targetCreators = exportScope === 'all' ? creators : creators.filter((c) => selectedIds.includes(c.id));
  const activePlatforms = PLATFORMS.filter((p) => platforms[p]);

  const handleExport = async () => {
    const XLSX = await import('xlsx');

    const rows = targetCreators.map((c) => {
      const row: Record<string, string | number> = {};
      if (baseFields.name) row['Nom'] = c.name;
      if (baseFields.handle) row['Handle'] = c.handle;
      if (baseFields.category) row['Catégorie'] = c.category;
      if (baseFields.city) row['Ville'] = c.city;
      if (baseFields.followers) row['Followers'] = c.followers;
      if (baseFields.engagement) row['Engagement (%)'] = c.engagement;
      if (baseFields.momentum) row['Momentum Score'] = c.momentum;
      if (baseFields.campaigns) row['Campagnes'] = c.campaigns;
      if (baseFields.status) row['Statut'] = c.status;
      if (fields.email) row['Email'] = c.email || '';
      if (fields.phone) row['Téléphone'] = c.phone || '';

      activePlatforms.forEach((p) => {
        const label = PLATFORM_LABELS[p];
        const data = c[p];
        if (fields.stats && data) {
          row[`${label} - Followers`] = data.followers;
          row[`${label} - Engagement (%)`] = data.engagement;
          row[`${label} - Avg Views`] = data.avgViews;
        } else if (!fields.stats) {
          row[`${label}`] = data ? 'Oui' : 'Non';
        }
      });

      return row;
    });

    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Créateurs');
    XLSX.writeFile(wb, `360_creators_export_${new Date().toISOString().slice(0, 10)}.xlsx`);
    onClose();
  };

  const previewCount = targetCreators.length;
  const colCount = Object.values(baseFields).filter(Boolean).length + (
  fields.email ? 1 : 0) + (fields.phone ? 1 : 0) +
  activePlatforms.length * (fields.stats ? 3 : 1);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-2xl w-full max-w-xl shadow-2xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-border sticky top-0 bg-card z-10">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-positive/15 flex items-center justify-center">
              <Icon name="ArrowDownTrayIcon" size={16} className="text-positive" />
            </div>
            <h2 className="text-base font-700 text-foreground">Exporter en Excel</h2>
          </div>
          <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-muted text-muted-foreground hover:text-foreground transition-all">
            <Icon name="XMarkIcon" size={18} />
          </button>
        </div>

        <div className="p-6 space-y-6">
          {/* Scope */}
          <div>
            <p className="text-xs font-700 text-muted-foreground uppercase tracking-wide mb-3">Influenceurs à exporter</p>
            <div className="grid grid-cols-2 gap-2">
              {(['all', 'selected'] as const).map((s) =>
              <button key={s} onClick={() => setExportScope(s)}
              className={`flex items-center gap-2 px-4 py-3 rounded-xl border text-sm font-600 transition-all ${
              exportScope === s ? 'border-primary bg-primary/10 text-primary' : 'border-border bg-muted text-muted-foreground hover:text-foreground'}`
              }>
                  <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${exportScope === s ? 'border-primary' : 'border-border'}`}>
                    {exportScope === s && <div className="w-2 h-2 rounded-full bg-primary" />}
                  </div>
                  {s === 'all' ? `Tous (${creators.length})` : `Sélectionnés (${selectedIds.length})`}
                </button>
              )}
            </div>
          </div>

          {/* Platforms */}
          <div>
            <p className="text-xs font-700 text-muted-foreground uppercase tracking-wide mb-3">Plateformes</p>
            <div className="grid grid-cols-2 gap-2">
              {PLATFORMS.map((p) =>
              <button key={p} onClick={() => togglePlatform(p)}
              className={`flex items-center gap-2 px-3 py-2.5 rounded-xl border text-sm font-600 transition-all ${
              platforms[p] ? `border ${PLATFORM_COLORS[p]}` : 'border-border bg-muted text-muted-foreground hover:text-foreground'}`
              }>
                  <div className={`w-4 h-4 rounded border-2 flex items-center justify-center flex-shrink-0 ${platforms[p] ? 'border-current bg-current/20' : 'border-border'}`}>
                    {platforms[p] && <Icon name="CheckIcon" size={10} className="text-current" />}
                  </div>
                  {PLATFORM_LABELS[p]}
                </button>
              )}
            </div>
          </div>

          {/* Data fields */}
          <div>
            <p className="text-xs font-700 text-muted-foreground uppercase tracking-wide mb-3">Données à inclure</p>
            <div className="space-y-2">
              {/* Base fields */}
              <div className="bg-muted/50 rounded-xl p-3">
                <p className="text-xs font-600 text-muted-foreground mb-2">Informations générales</p>
                <div className="grid grid-cols-3 gap-1.5">
                  {(Object.keys(baseFields) as (keyof typeof baseFields)[]).map((f) => {
                    const labels: Record<keyof typeof baseFields, string> = {
                      name: 'Nom', handle: 'Handle', category: 'Catégorie', city: 'Ville',
                      followers: 'Followers', engagement: 'Engagement', momentum: 'Momentum',
                      campaigns: 'Campagnes', status: 'Statut'
                    };
                    return (
                      <button key={f} onClick={() => toggleBase(f)}
                      className={`flex items-center gap-1.5 px-2 py-1.5 rounded-lg border text-xs font-600 transition-all ${
                      baseFields[f] ? 'border-primary/40 bg-primary/10 text-primary' : 'border-border bg-card text-muted-foreground hover:text-foreground'}`
                      }>
                        <div className={`w-3 h-3 rounded border flex items-center justify-center flex-shrink-0 ${baseFields[f] ? 'border-primary bg-primary' : 'border-border'}`}>
                          {baseFields[f] && <Icon name="CheckIcon" size={8} className="text-primary-foreground" />}
                        </div>
                        {labels[f]}
                      </button>);

                  })}
                </div>
              </div>

              {/* Contact */}
              <div className="bg-muted/50 rounded-xl p-3">
                <p className="text-xs font-600 text-muted-foreground mb-2">Contact</p>
                <div className="flex gap-2">
                  {(['email', 'phone'] as const).map((f) =>
                  <button key={f} onClick={() => toggleField(f)}
                  className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-xs font-600 transition-all ${
                  fields[f] ? 'border-primary/40 bg-primary/10 text-primary' : 'border-border bg-card text-muted-foreground hover:text-foreground'}`
                  }>
                      <div className={`w-3 h-3 rounded border flex items-center justify-center flex-shrink-0 ${fields[f] ? 'border-primary bg-primary' : 'border-border'}`}>
                        {fields[f] && <Icon name="CheckIcon" size={8} className="text-primary-foreground" />}
                      </div>
                      {f === 'email' ? 'Email' : 'Téléphone'}
                    </button>
                  )}
                </div>
              </div>

              {/* Platform stats toggle */}
              {activePlatforms.length > 0 &&
              <div className="bg-muted/50 rounded-xl p-3">
                  <p className="text-xs font-600 text-muted-foreground mb-2">Statistiques plateformes</p>
                  <button onClick={() => toggleField('stats')}
                className={`flex items-center gap-2 px-3 py-1.5 rounded-lg border text-xs font-600 transition-all ${
                fields.stats ? 'border-primary/40 bg-primary/10 text-primary' : 'border-border bg-card text-muted-foreground hover:text-foreground'}`
                }>
                    <div className={`w-3 h-3 rounded border flex items-center justify-center flex-shrink-0 ${fields.stats ? 'border-primary bg-primary' : 'border-border'}`}>
                      {fields.stats && <Icon name="CheckIcon" size={8} className="text-primary-foreground" />}
                    </div>
                    Inclure les stats (followers, engagement, avg views)
                  </button>
                </div>
              }
            </div>
          </div>

          {/* Preview summary */}
          <div className="bg-positive/5 border border-positive/20 rounded-xl px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Icon name="TableCellsIcon" size={16} className="text-positive" />
              <span className="text-sm font-600 text-foreground">Aperçu de l'export</span>
            </div>
            <div className="flex items-center gap-4 text-xs text-muted-foreground">
              <span><span className="font-700 text-foreground">{previewCount}</span> lignes</span>
              <span><span className="font-700 text-foreground">{colCount}</span> colonnes</span>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-border">
          <button onClick={onClose} className="px-4 py-2 rounded-lg text-sm font-600 bg-muted text-muted-foreground hover:text-foreground transition-all">
            Annuler
          </button>
          <button onClick={handleExport}
          disabled={previewCount === 0 || colCount === 0}
          className="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-700 bg-positive text-white hover:bg-positive/90 transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed">
            <Icon name="ArrowDownTrayIcon" size={16} />
            Télécharger Excel
          </button>
        </div>
      </div>
    </div>);

}

// ─── Main Table ────────────────────────────────────────────────────────────────
export default function AdminCreatorTable() {
  const [creators, setCreators] = useState<Creator[]>(creatorsData);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState<string>('all');
  const [sortCol, setSortCol] = useState('momentum');
  const [sortDir, setSortDir] = useState<'asc' | 'desc'>('desc');
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [deleteTarget, setDeleteTarget] = useState<string | null>(null);
  const [openStatusMenu, setOpenStatusMenu] = useState<string | null>(null);
  const [editTarget, setEditTarget] = useState<Creator | null>(null);
  const [showExport, setShowExport] = useState(false);
  const [page, setPage] = useState(1);
  const perPage = 8;

  const filtered = creators.
  filter((c) => {
    const matchSearch = c.name.toLowerCase().includes(search.toLowerCase()) ||
    c.handle.toLowerCase().includes(search.toLowerCase());
    const matchStatus = statusFilter === 'all' || c.status === statusFilter;
    return matchSearch && matchStatus;
  }).
  sort((a, b) => {
    let av: number | string = 0;
    let bv: number | string = 0;
    if (sortCol === 'momentum') {av = a.momentum;bv = b.momentum;} else
    if (sortCol === 'engagement') {av = a.engagement;bv = b.engagement;} else
    if (sortCol === 'campaigns') {av = a.campaigns;bv = b.campaigns;} else
    if (sortCol === 'name') {av = a.name;bv = b.name;}
    if (typeof av === 'string') return sortDir === 'asc' ? av.localeCompare(bv as string) : (bv as string).localeCompare(av);
    return sortDir === 'asc' ? (av as number) - (bv as number) : (bv as number) - (av as number);
  });

  const totalPages = Math.ceil(filtered.length / perPage);
  const paginated = filtered.slice((page - 1) * perPage, page * perPage);

  const toggleSort = (col: string) => {
    if (sortCol === col) setSortDir((d) => d === 'asc' ? 'desc' : 'asc');else
    {setSortCol(col);setSortDir('desc');}
  };

  const toggleSelect = (id: string) => {
    setSelectedIds((prev) => prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]);
  };

  const toggleAll = () => {
    setSelectedIds((prev) => prev.length === paginated.length ? [] : paginated.map((c) => c.id));
  };

  const changeStatus = (id: string, status: CreatorStatus) => {
    setCreators((prev) => prev.map((c) => c.id === id ? { ...c, status } : c));
    setOpenStatusMenu(null);
  };

  const confirmDelete = () => {
    if (deleteTarget) {
      setCreators((prev) => prev.filter((c) => c.id !== deleteTarget));
      setSelectedIds((prev) => prev.filter((id) => id !== deleteTarget));
      setDeleteTarget(null);
    }
  };

  const saveEdit = (updated: Creator) => {
    setCreators((prev) => prev.map((c) => c.id === updated.id ? updated : c));
    setEditTarget(null);
  };

  const SortIcon = ({ col }: {col: string;}) =>
  <span className="ml-1 inline-flex flex-col">
      <svg width="8" height="8" viewBox="0 0 8 8" className={sortCol === col && sortDir === 'asc' ? 'text-primary' : 'text-border'} fill="currentColor"><path d="M4 0L8 6H0z" /></svg>
      <svg width="8" height="8" viewBox="0 0 8 8" className={sortCol === col && sortDir === 'desc' ? 'text-primary' : 'text-border'} fill="currentColor"><path d="M4 8L0 2h8z" /></svg>
    </span>;


  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-base font-700 text-foreground">Gestion des créateurs</h2>
        <div className="flex items-center gap-2">
          <span className="text-xs text-muted-foreground">{filtered.length} créateurs</span>
          <button
            onClick={() => setShowExport(true)}
            className="flex items-center gap-2 bg-positive/15 hover:bg-positive/25 text-positive border border-positive/30 text-xs font-700 px-3 py-1.5 rounded-lg transition-all active:scale-95">
            <Icon name="ArrowDownTrayIcon" size={13} />
            Exporter Excel
          </button>
        </div>
      </div>

      {/* Toolbar */}
      <div className="flex items-center gap-3 mb-4 flex-wrap">
        <div className="flex items-center gap-2 bg-card border border-border rounded-lg px-3 py-2 flex-1 min-w-48 focus-within:border-primary transition-colors">
          <Icon name="MagnifyingGlassIcon" size={14} className="text-muted-foreground" />
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Rechercher un créateur..."
            className="bg-transparent text-sm text-foreground placeholder-muted-foreground outline-none flex-1" />
        </div>
        <div className="flex items-center gap-1 bg-muted rounded-lg p-1">
          {['all', 'active', 'pending', 'paused', 'draft'].map((s) =>
          <button
            key={`sf-${s}`}
            onClick={() => {setStatusFilter(s);setPage(1);}}
            className={`px-3 py-1.5 rounded-md text-xs font-600 transition-all capitalize ${statusFilter === s ? 'bg-card text-foreground' : 'text-muted-foreground hover:text-foreground'}`}>
              {s === 'all' ? 'Tous' : s}
            </button>
          )}
        </div>
      </div>

      {/* Bulk action bar */}
      {selectedIds.length > 0 &&
      <div className="flex items-center gap-3 bg-primary/10 border border-primary/20 rounded-lg px-4 py-3 mb-4 animate-slide-up">
          <span className="text-sm font-600 text-primary">{selectedIds.length} sélectionné(s)</span>
          <div className="flex items-center gap-2 ml-auto">
            <button
            onClick={() => setShowExport(true)}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-600 bg-positive/15 text-positive hover:bg-positive/25 transition-all">
              <Icon name="ArrowDownTrayIcon" size={12} />
              Exporter sélection
            </button>
            <button className="px-3 py-1.5 rounded-lg text-xs font-600 bg-positive/15 text-positive hover:bg-positive/25 transition-all">
              Vérifier tout
            </button>
            <button className="px-3 py-1.5 rounded-lg text-xs font-600 bg-warning/15 text-warning hover:bg-warning/25 transition-all">
              Mettre en pause
            </button>
            <button onClick={() => setSelectedIds([])} className="px-3 py-1.5 rounded-lg text-xs font-600 bg-muted text-muted-foreground hover:text-foreground transition-all">
              Annuler
            </button>
          </div>
        </div>
      }

      {/* Table */}
      <div className="bg-card border border-border rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border bg-muted/50">
                <th className="w-10 px-4 py-3">
                  <input type="checkbox" checked={selectedIds.length === paginated.length && paginated.length > 0} onChange={toggleAll} className="accent-primary" />
                </th>
                <th className="px-4 py-3 text-left">
                  <button onClick={() => toggleSort('name')} className="flex items-center text-xs font-600 uppercase tracking-wide text-muted-foreground hover:text-foreground">
                    Créateur <SortIcon col="name" />
                  </button>
                </th>
                <th className="px-4 py-3 text-left text-xs font-600 uppercase tracking-wide text-muted-foreground">Catégorie</th>
                <th className="px-4 py-3 text-left text-xs font-600 uppercase tracking-wide text-muted-foreground">Ville</th>
                <th className="px-4 py-3 text-left text-xs font-600 uppercase tracking-wide text-muted-foreground">Followers</th>
                <th className="px-4 py-3 text-left">
                  <button onClick={() => toggleSort('engagement')} className="flex items-center text-xs font-600 uppercase tracking-wide text-muted-foreground hover:text-foreground">
                    Engage <SortIcon col="engagement" />
                  </button>
                </th>
                <th className="px-4 py-3 text-left">
                  <button onClick={() => toggleSort('momentum')} className="flex items-center text-xs font-600 uppercase tracking-wide text-muted-foreground hover:text-foreground">
                    Momentum <SortIcon col="momentum" />
                  </button>
                </th>
                <th className="px-4 py-3 text-left text-xs font-600 uppercase tracking-wide text-muted-foreground">Statut</th>
                <th className="px-4 py-3 text-left text-xs font-600 uppercase tracking-wide text-muted-foreground">Vérifié</th>
                <th className="px-4 py-3 text-left">
                  <button onClick={() => toggleSort('campaigns')} className="flex items-center text-xs font-600 uppercase tracking-wide text-muted-foreground hover:text-foreground">
                    Campagnes <SortIcon col="campaigns" />
                  </button>
                </th>
                <th className="px-4 py-3 text-left text-xs font-600 uppercase tracking-wide text-muted-foreground">Dernière activité</th>
                <th className="px-4 py-3 text-right text-xs font-600 uppercase tracking-wide text-muted-foreground">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {paginated.map((creator) =>
              <tr key={creator.id} className={`group hover:bg-muted/40 transition-all ${selectedIds.includes(creator.id) ? 'bg-primary/5' : ''}`}>
                  <td className="px-4 py-3">
                    <input type="checkbox" checked={selectedIds.includes(creator.id)} onChange={() => toggleSelect(creator.id)} className="accent-primary" />
                  </td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full overflow-hidden border border-border flex-shrink-0">
                        <AppImage src={creator.avatar} alt={creator.avatarAlt} width={36} height={36} className="w-full h-full object-cover" />
                      </div>
                      <div>
                        <p className="text-sm font-700 text-foreground">{creator.name}</p>
                        <p className="text-xs text-muted-foreground">{creator.handle}</p>
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3"><span className="text-xs text-muted-foreground">{creator.category}</span></td>
                  <td className="px-4 py-3"><span className="text-xs text-muted-foreground">{creator.city}</span></td>
                  <td className="px-4 py-3"><span className="text-sm font-600 text-foreground font-mono">{creator.followers}</span></td>
                  <td className="px-4 py-3">
                    <span className={`text-sm font-700 font-mono ${creator.engagement >= 8 ? 'text-positive' : creator.engagement >= 5 ? 'text-foreground' : 'text-warning'}`}>
                      {creator.engagement}%
                    </span>
                  </td>
                  <td className="px-4 py-3"><MomentumBadge score={creator.momentum} size="sm" /></td>
                  <td className="px-4 py-3 relative">
                    <button onClick={() => setOpenStatusMenu(openStatusMenu === creator.id ? null : creator.id)} className="inline-flex items-center gap-1">
                      <StatusBadge variant={creator.status} size="sm" />
                      <Icon name="ChevronDownIcon" size={10} className="text-muted-foreground" />
                    </button>
                    {openStatusMenu === creator.id &&
                  <div className="absolute left-0 top-full mt-1 z-30 bg-card border border-border rounded-lg shadow-xl py-1 min-w-36 animate-fade-in">
                        {statusOptions.map((s) =>
                    <button key={`status-opt-${creator.id}-${s}`} onClick={() => changeStatus(creator.id, s)}
                    className="w-full flex items-center gap-2 px-3 py-2 text-xs hover:bg-muted transition-all text-left capitalize">
                            <StatusBadge variant={s} size="sm" label={s} />
                          </button>
                    )}
                      </div>
                  }
                  </td>
                  <td className="px-4 py-3">
                    {creator.verified ?
                  <span className="flex items-center gap-1 text-xs text-positive font-600"><Icon name="CheckBadgeIcon" size={14} className="text-positive" />Vérifié</span> :
                  <span className="text-xs text-muted-foreground">Non vérifié</span>
                  }
                  </td>
                  <td className="px-4 py-3"><span className="text-sm font-600 text-foreground font-mono">{creator.campaigns}</span></td>
                  <td className="px-4 py-3"><span className="text-xs text-muted-foreground">{creator.lastActive}</span></td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-1 justify-end opacity-0 group-hover:opacity-100 transition-opacity">
                      <Link href="/creator-professional-page"
                    className="p-1.5 rounded-lg hover:bg-muted text-muted-foreground hover:text-foreground transition-all" title="Voir le profil">
                        <Icon name="EyeIcon" size={14} />
                      </Link>
                      <button
                      onClick={() => setEditTarget(creator)}
                      className="p-1.5 rounded-lg hover:bg-primary/10 text-muted-foreground hover:text-primary transition-all"
                      title="Modifier ce créateur">
                        <Icon name="PencilSquareIcon" size={14} />
                      </button>
                      <button
                      onClick={() => setDeleteTarget(creator.id)}
                      className="p-1.5 rounded-lg hover:bg-negative/10 text-muted-foreground hover:text-negative transition-all"
                      title="Supprimer ce créateur">
                        <Icon name="TrashIcon" size={14} />
                      </button>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-between px-4 py-3 border-t border-border">
          <p className="text-xs text-muted-foreground">
            {(page - 1) * perPage + 1}–{Math.min(page * perPage, filtered.length)} sur {filtered.length} créateurs
          </p>
          <div className="flex items-center gap-1">
            <button onClick={() => setPage((p) => Math.max(p - 1, 1))} disabled={page === 1}
            className="p-1.5 rounded-lg hover:bg-muted text-muted-foreground disabled:opacity-40 disabled:cursor-not-allowed transition-all">
              <Icon name="ChevronLeftIcon" size={14} />
            </button>
            {Array.from({ length: totalPages }).map((_, i) =>
            <button key={`pg-${i + 1}`} onClick={() => setPage(i + 1)}
            className={`w-7 h-7 rounded-lg text-xs font-600 transition-all ${page === i + 1 ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-muted hover:text-foreground'}`}>
                {i + 1}
              </button>
            )}
            <button onClick={() => setPage((p) => Math.min(p + 1, totalPages))} disabled={page === totalPages}
            className="p-1.5 rounded-lg hover:bg-muted text-muted-foreground disabled:opacity-40 disabled:cursor-not-allowed transition-all">
              <Icon name="ChevronRightIcon" size={14} />
            </button>
          </div>
        </div>
      </div>

      {/* Modals */}
      <ConfirmModal
        open={!!deleteTarget}
        title="Supprimer ce créateur"
        description="Cette action est irréversible. Le profil, les statistiques et l'historique de campagnes seront définitivement supprimés."
        confirmLabel="Supprimer définitivement"
        variant="danger"
        onConfirm={confirmDelete}
        onCancel={() => setDeleteTarget(null)} />

      {editTarget &&
      <EditCreatorModal
        creator={editTarget}
        onSave={saveEdit}
        onClose={() => setEditTarget(null)} />
      }

      {showExport &&
      <ExcelExportModal
        creators={creators}
        selectedIds={selectedIds}
        onClose={() => setShowExport(false)} />
      }
    </div>);

}